'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { NATIONWIDE_FESTIVAL_RADIUS_METER } from '@/constants/festival';
import { DEFAULT_LOCATION } from '@/constants/geo';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { EMPTY_AI_SUMMARY_MESSAGE, PAGE_SIZE, PREVIEW_SIZE } from '../../constants';
import { formatApplicationPeriod } from '../../utils';
import type { PolicyData } from '../PolicySearch/SearchPolicyCard';
import { SearchEmptyResults } from '../SearchEmptyResults';
import { BestContentsPreviewSection } from './BestContentsPreviewSection';
import { DonationBusinessPreviewSection } from './DonationBusinessPreviewSection';
import { FestivalPreviewSection } from './FestivalPreviewSection';
import { GiftPreviewSection } from './GiftPreviewSection';
import { HometownNewsPreviewSection } from './HometownNewsPreviewSection';
import { LocalMarketPreviewSection } from './LocalMarketPreviewSection';
import { PolicyPreviewSection } from './PolicyPreviewSection';
const SLIDER_PREVIEW_SIZE = PAGE_SIZE;
const DONATION_PREVIEW_SIZE = 3;
interface AllSearchProps {
  keyword: string;
}
export function AllSearch(t0) {
  const $ = _c(72);
  const {
    keyword
  } = t0;
  let t1;
  if ($[0] !== keyword) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/policies"]({
      query: {
        searchKeyword: keyword || undefined,
        policySort: "SCORE",
        page: 1,
        size: PREVIEW_SIZE
      }
    });
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      ...t1,
      select: _temp2
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const policyQuery = useQuery(t2);
  let t3;
  if ($[4] !== keyword) {
    t3 = UnauthQueryOptions["get:/wello/v2/allows/query/hometown-news"]({
      query: {
        searchKeyword: keyword,
        hometownNewsSort: "LATEST",
        page: 1,
        size: PREVIEW_SIZE
      }
    });
    $[4] = keyword;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      ...t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const hometownNewsQuery = useQuery(t4);
  let t5;
  if ($[8] !== keyword) {
    t5 = UnauthQueryOptions["get:/wello/v2/allows/query/tour/festival"]({
      query: {
        subRegionCode: DEFAULT_LOCATION.codeSubRegion,
        radius: NATIONWIDE_FESTIVAL_RADIUS_METER,
        searchKeyword: keyword || undefined,
        page: 1,
        size: SLIDER_PREVIEW_SIZE
      }
    });
    $[8] = keyword;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = {
      ...t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const festivalQuery = useQuery(t6);
  let t7;
  if ($[12] !== keyword) {
    t7 = UnauthQueryOptions["get:/wello/v2/allows/query/best-contents"]({
      query: {
        searchKeyword: keyword,
        bestContentsSort: "LATEST",
        page: 1,
        size: PREVIEW_SIZE
      }
    });
    $[12] = keyword;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = {
      ...t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const bestContentsQuery = useQuery(t8);
  let t9;
  if ($[16] !== keyword) {
    t9 = UnauthQueryOptions["get:/wello/v2/allows/query/gift-products"]({
      query: {
        searchKeyword: keyword,
        page: 1,
        size: SLIDER_PREVIEW_SIZE
      }
    });
    $[16] = keyword;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = {
      ...t9
    };
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const giftQuery = useQuery(t10);
  let t11;
  if ($[20] !== keyword) {
    t11 = UnauthQueryOptions["get:/wello/v2/allows/query/donations-businesses"]({
      query: {
        searchKeyword: keyword,
        page: 1,
        size: DONATION_PREVIEW_SIZE
      }
    });
    $[20] = keyword;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11) {
    t12 = {
      ...t11
    };
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const donationBusinessQuery = useQuery(t12);
  let t13;
  if ($[24] !== keyword) {
    t13 = UnauthQueryOptions["get:/wello/v2/allows/query/local-market"]({
      query: {
        searchKeyword: keyword,
        page: 1,
        size: SLIDER_PREVIEW_SIZE
      }
    });
    $[24] = keyword;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = {
      ...t13
    };
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const localMarketQuery = useQuery(t14);
  let t15;
  if ($[28] !== policyQuery.data?.items) {
    t15 = policyQuery.data?.items ?? [];
    $[28] = policyQuery.data?.items;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  const policyItems = t15;
  const policyTotal = policyQuery.data?.totalCount ?? 0;
  let t16;
  if ($[30] !== hometownNewsQuery.data?.context?.contents) {
    t16 = hometownNewsQuery.data?.context?.contents ?? [];
    $[30] = hometownNewsQuery.data?.context?.contents;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const hometownNewsItems = t16;
  let t17;
  if ($[32] !== festivalQuery.data?.context?.content) {
    t17 = festivalQuery.data?.context?.content ?? [];
    $[32] = festivalQuery.data?.context?.content;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const festivalItems = t17;
  let t18;
  if ($[34] !== bestContentsQuery.data?.context?.contents) {
    t18 = bestContentsQuery.data?.context?.contents ?? [];
    $[34] = bestContentsQuery.data?.context?.contents;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const bestContentsItems = t18;
  let t19;
  if ($[36] !== giftQuery.data?.context?.contents) {
    t19 = giftQuery.data?.context?.contents ?? [];
    $[36] = giftQuery.data?.context?.contents;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  const giftItems = t19;
  let t20;
  if ($[38] !== donationBusinessQuery.data?.context?.contents) {
    t20 = donationBusinessQuery.data?.context?.contents ?? [];
    $[38] = donationBusinessQuery.data?.context?.contents;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const donationItems = t20;
  let t21;
  if ($[40] !== localMarketQuery.data?.context?.contents) {
    t21 = localMarketQuery.data?.context?.contents ?? [];
    $[40] = localMarketQuery.data?.context?.contents;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  const localMarketItems = t21;
  const isAnyPending = policyQuery.isPending || hometownNewsQuery.isPending || festivalQuery.isPending || bestContentsQuery.isPending || giftQuery.isPending || donationBusinessQuery.isPending || localMarketQuery.isPending;
  const isAllEmpty = !isAnyPending && policyItems.length < 1 && hometownNewsItems.length < 1 && festivalItems.length < 1 && bestContentsItems.length < 1 && giftItems.length < 1 && donationItems.length < 1 && localMarketItems.length < 1;
  const lastTrackedKeyword = useRef(null);
  let t22;
  let t23;
  if ($[42] !== isAllEmpty || $[43] !== isAnyPending || $[44] !== keyword) {
    t22 = () => {
      if (!keyword || isAnyPending) {
        return;
      }
      if (lastTrackedKeyword.current === keyword) {
        return;
      }
      lastTrackedKeyword.current = keyword;
      trackGtmEvent(GTM_EVENT_TYPE.SEARCH, {
        search_type: "\uD1B5\uD569\uAC80\uC0C9",
        search_result: isAllEmpty ? "N" : "Y",
        search_term: keyword,
        search_category: "all"
      });
    };
    t23 = [keyword, isAnyPending, isAllEmpty];
    $[42] = isAllEmpty;
    $[43] = isAnyPending;
    $[44] = keyword;
    $[45] = t22;
    $[46] = t23;
  } else {
    t22 = $[45];
    t23 = $[46];
  }
  useEffect(t22, t23);
  let t24;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <SearchSideAdBanner />;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== bestContentsItems || $[49] !== bestContentsQuery.data?.context?.totalCount || $[50] !== bestContentsQuery.isPending || $[51] !== donationBusinessQuery.data?.context?.totalCount || $[52] !== donationBusinessQuery.isPending || $[53] !== donationItems || $[54] !== festivalItems || $[55] !== festivalQuery.data?.context?.totalElements || $[56] !== festivalQuery.isPending || $[57] !== giftItems || $[58] !== giftQuery.data?.context?.totalCount || $[59] !== giftQuery.isPending || $[60] !== hometownNewsItems || $[61] !== hometownNewsQuery.data?.context?.totalCount || $[62] !== hometownNewsQuery.isPending || $[63] !== isAllEmpty || $[64] !== keyword || $[65] !== localMarketItems || $[66] !== localMarketQuery.data?.context?.totalCount || $[67] !== localMarketQuery.isPending || $[68] !== policyItems || $[69] !== policyQuery.isPending || $[70] !== policyTotal) {
    t25 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" rightAside={t24}>{isAllEmpty ? <SearchEmptyResults /> : <div className="flex flex-col gap-40 pb-40 mobile-tablet:pb-24"><PolicyPreviewSection keyword={keyword} items={policyItems} totalCount={policyTotal} isLoading={policyQuery.isPending} /><HometownNewsPreviewSection keyword={keyword} items={hometownNewsItems} totalCount={hometownNewsQuery.data?.context?.totalCount ?? 0} isLoading={hometownNewsQuery.isPending} /><FestivalPreviewSection keyword={keyword} items={festivalItems} totalCount={festivalQuery.data?.context?.totalElements ?? 0} isLoading={festivalQuery.isPending} /><BestContentsPreviewSection keyword={keyword} items={bestContentsItems} totalCount={bestContentsQuery.data?.context?.totalCount ?? 0} isLoading={bestContentsQuery.isPending} /><GiftPreviewSection keyword={keyword} items={giftItems} totalCount={giftQuery.data?.context?.totalCount ?? 0} isLoading={giftQuery.isPending} /><DonationBusinessPreviewSection keyword={keyword} items={donationItems} totalCount={donationBusinessQuery.data?.context?.totalCount ?? 0} isLoading={donationBusinessQuery.isPending} /><LocalMarketPreviewSection keyword={keyword} items={localMarketItems} totalCount={localMarketQuery.data?.context?.totalCount ?? 0} isLoading={localMarketQuery.isPending} /></div>}</DesktopPageShell>;
    $[48] = bestContentsItems;
    $[49] = bestContentsQuery.data?.context?.totalCount;
    $[50] = bestContentsQuery.isPending;
    $[51] = donationBusinessQuery.data?.context?.totalCount;
    $[52] = donationBusinessQuery.isPending;
    $[53] = donationItems;
    $[54] = festivalItems;
    $[55] = festivalQuery.data?.context?.totalElements;
    $[56] = festivalQuery.isPending;
    $[57] = giftItems;
    $[58] = giftQuery.data?.context?.totalCount;
    $[59] = giftQuery.isPending;
    $[60] = hometownNewsItems;
    $[61] = hometownNewsQuery.data?.context?.totalCount;
    $[62] = hometownNewsQuery.isPending;
    $[63] = isAllEmpty;
    $[64] = keyword;
    $[65] = localMarketItems;
    $[66] = localMarketQuery.data?.context?.totalCount;
    $[67] = localMarketQuery.isPending;
    $[68] = policyItems;
    $[69] = policyQuery.isPending;
    $[70] = policyTotal;
    $[71] = t25;
  } else {
    t25 = $[71];
  }
  return t25;
}
function _temp2(data) {
  return {
    items: (data.context?.contents ?? []).map(_temp),
    totalCount: data.context?.totalCount ?? 0
  };
}
function _temp(policy) {
  return {
    id: policy.metaPolicyIdIdx ?? String(policy.id ?? ""),
    contentId: policy.id,
    title: policy.policyName ?? "",
    aiSummary: policy.aiSummary ?? EMPTY_AI_SUMMARY_MESSAGE,
    applicationPeriod: formatApplicationPeriod(policy.dueDateStart, policy.dueDateEnd),
    agencyName: policy.agency ?? "",
    agencyLogo: policy.agencyLogo ?? "",
    isBookmarked: Boolean(policy.wishlistYN)
  };
}